// @flow
import React, { useState } from 'react'
// import { spring } from 'popmotion'
import posed from 'react-pose'
import Drawer from '@material-ui/core/Drawer'
import leftArrow from '@assets/images/leftArrow.png'
import Mine from '../Mine'
import './menu.scss'

export default function Menu (props) {
  const [mineShow, setMineShow] = useState(false)
  const posedProps = {
    draggable: true,
    // dragEnd: {
    //   x: 0,
    //   y: 0,
    //   transition: spring
    // }
    dragBounds: {
      left: -(document.documentElement.clientWidth - 29 / 2 - 55),
      right: 29 / 2,
      bottom: 163 / 2,
      top: -(document.documentElement.clientHeight - 163 / 2 - 55)
    }
  }

  const Box = posed.div(posedProps)
  const Example = () => (
    <Box className='menu' onClick={() => setMineShow(true)}>
      <div className='menu-inner' />
    </Box>
  )
  const Close = () => (
    <Box className='close' onClick={() => setMineShow(false)}>
      <img className='close-inner' src={leftArrow} alt='图片' />
    </Box>
  )
  return (
    <React.Fragment>
      {mineShow ? <Close /> : <Example />}
      <Drawer
        anchor='left'
        className='mine-container'
        open={mineShow}
        onClose={() => setMineShow(false)}>
        <Mine onClose={() => setMineShow(false)} {...props} />
      </Drawer>
    </React.Fragment>
  )
}
